/**
 * 核心 
 * @module Core
 */

;(function (ui,$) {
   
/**
 * init 页面初始化, 默认已经执行
 * @namespace  bui
 * @class  init
 * @constructor 
 * @example
 *
     bui.init()
 *
 */
  ui.init = function () {

    //viewport初始化
    if( ui.platform().isWindow() || ui.platform().isMac() ){
      //针对PC处理
        window.viewport = ui.viewport(60);
    }else if( ui.platform().isIpad() ){
      // 64 || 70
       window.viewport = ui.viewport(70);
    }else{
       window.viewport = ui.viewport();

    }
    
    $(document).ready(function () {
      //初始化main高度
        window.viewport.init();

        // 终端加快点击插件
        if( typeof FastClick == "function" ){

          FastClick.attach(document.body);
        }
    });

    return this;
  };

  //初始化
  ui.init();

  return ui;

})( bui || {}, libs );
